import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nexus-icon-building',
  templateUrl: './icon-building.component.html',
  styleUrls: ['./icon-building.component.css']
})
export class IconBuildingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
